/**
 * 관리자 레이아웃이 넘기는 값 — adm/layouts/main 의 `<script type="application/json" id="adm-layout-data">`.
 *
 * 메뉴·관리자 이름·앱 버전·악덕 상태 라벨·아바타 목록처럼 화면마다 같은 서버 값을 여기서 읽는다.
 * popup·bare 레이아웃과 /ma 에는 블록이 없다 — 그때는 fallback 이 돌아온다.
 * (.ai/frontend.md 「서버 값을 JS 로 넘기는 방법」)
 */
let cache = null;

export default {
    get(key, fallback) {
        if (cache === null) {
            const el = document.getElementById('adm-layout-data');
            if (!el) return fallback;   // 블록이 없는 레이아웃이거나 아직 안 그려졌다 — 저장하지 않는다
            try { cache = JSON.parse(el.textContent) || {}; }
            catch (e) { console.error('adm-layout-data', e); cache = {}; }
        }
        return (key in cache && cache[key] !== null) ? cache[key] : fallback;
    },
};
